import { useMemo } from 'react';
import { StationeryPrintOrderDeliveryMethodEnum } from '@graphql/generated';
import { useTranslation } from '@shared/core';

export const useShippingMethodLabelsAndDescriptions = () => {
  const { tq } = useTranslation('stationery');

  return useMemo<
    Record<
      Exclude<StationeryPrintOrderDeliveryMethodEnum, 'free' | 'mail_innovations_standard_flat' | 'ups_canada_express_saver' | 'ups_express_saver'>,
      { title: string; description?: string }
    >
  >(
    () => ({
      mail_innovations_expedited_parcel: {
        title: tq`Economy Shipping`,
        description: tq`Arrives in 14-16 days`,
      },
      standard: {
        title: tq`Standard Shipping`,
        description: tq`Arrives in 12-14 days`,
      },
      express: {
        title: tq`Express Shipping`,
        description: tq`Arrives in 8 days`,
      },
      usps_international_first_class: {
        title: tq`International Economy Shipping`,
        description: tq`Arrives in 12-21 days, tracking only available while in the US`,
      },
      ups_ground_canada_standard: {
        title: tq`Standard Shipping`,
        description: tq`Arrives in 12-14 days`,
      },
      ups_international_express_saver: {
        title: tq`Worldwide Express Shipping`,
        description: tq`Arrives in 9-12 days`,
      },
    }),
    [tq],
  );
};
